;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"36cb73230380dbb3c6c8f6bee9cc7b9e5bab640f"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/hcp";import * as Sentry from '@sentry/nextjs';

const {
    initSentry,
} = require('../../libs/common-next/shared-sentry.client.config');

initSentry({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT,

    initialScope: {
        tags: {
            application_name: 'HCP',
        },
    },

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate:
        Number(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE) || 0.015,

    // Capture Replay for 10% of all sessions
    // Capture 100% of sessions with an error
    replaysSessionSampleRate:
        Number(process.env.NEXT_PUBLIC_REPLAYS_SESSION_SAMPLE_RATE) || 0.1,
    replaysOnErrorSampleRate:
        Number(process.env.NEXT_PUBLIC_REPLAYS_ON_ERROR_SAMPLE_RATE) || 1.0,

    // NOTE: The BrowserTracing and Replay was commented out to avoid performance issue
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.captureConsoleIntegration({
            levels: ['error'],
        }),
        Sentry.httpClientIntegration(),
    ],
});

export default Sentry;
